import React from "react";

interface CustomTileProps {
  releaseText: string;
  number: number;
  imageUrl: string;
  loading?: boolean;
  accent?: string;
}

const accentStyles: Record<
  string,
  { iconBg: string; iconColor: string; spark: string; trend?: string }
> = {
  "Total Leads": {
    iconBg: "bg-[#F9F0F4]",
    iconColor: "text-[#841C39]",
    spark: "#841C39",
    trend: "text-emerald-600",
  },
  "New Leads": {
    iconBg: "bg-[#F9F0F4]",
    iconColor: "text-[#841C39]",
    spark: "#841C39",
    trend: "text-emerald-600",
  },
  "In Progress": {
    iconBg: "bg-[#FFF7ED]",
    iconColor: "text-[#F59E0B]",
    spark: "#F59E0B",
    trend: "text-emerald-600",
  },
  Converted: {
    iconBg: "bg-[#ECFDF5]",
    iconColor: "text-[#10B981]",
    spark: "#10B981",
    trend: "text-emerald-600",
  },
  "Lost Leads": {
    iconBg: "bg-[#FEF2F2]",
    iconColor: "text-[#EF4444]",
    spark: "#EF4444",
    trend: "text-red-500",
  },
  Contact: {
    iconBg: "bg-[#ECFDF5]",
    iconColor: "text-[#10B981]",
    spark: "#10B981",
  },
  Lead: {
    iconBg: "bg-[#F9F0F4]",
    iconColor: "text-[#841C39]",
    spark: "#841C39",
  },
  Prospect: {
    iconBg: "bg-[#FFF7ED]",
    iconColor: "text-[#F59E0B]",
    spark: "#F59E0B",
  },
  Opportunity: {
    iconBg: "bg-[#FDF2F8]",
    iconColor: "text-[#EC4899]",
    spark: "#EC4899",
  },
  Closure: {
    iconBg: "bg-[#F9F0F4]",
    iconColor: "text-[#841C39]",
    spark: "#841C39",
  },
  "Conversion %": {
    iconBg: "bg-[#ECFDF5]",
    iconColor: "text-[#059669]",
    spark: "#059669",
    trend: "text-emerald-600",
  },
};

const Sparkline = ({ color }: { color: string }) => (
  <svg width="72" height="28" viewBox="0 0 72 28" fill="none" aria-hidden>
    <path
      d="M1 20 C10 18, 14 8, 22 12 S34 24, 42 16 S54 4, 62 10 S68 18, 71 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      fill="none"
      opacity="0.85"
    />
    <path
      d="M1 20 C10 18, 14 8, 22 12 S34 24, 42 16 S54 4, 62 10 S68 18, 71 14 L71 28 L1 28 Z"
      fill={color}
      opacity="0.12"
    />
  </svg>
);

function CustomTile({
  releaseText,
  number,
  imageUrl,
  loading,
}: CustomTileProps) {
  const accent =
    accentStyles[releaseText] || accentStyles["Total Leads"];

  return (
    <div className="flex min-w-[180px] flex-1 flex-col justify-between rounded-2xl border border-[#EEF0F5] bg-white p-4 shadow-[0_4px_20px_rgba(15,23,42,0.04)]">
      <div className="mb-3 flex items-start justify-between">
        <p className="text-sm font-medium text-[#6B7280]">{releaseText}</p>
        <div
          className={`flex h-9 w-9 items-center justify-center rounded-xl ${accent.iconBg}`}
        >
          <img
            src={imageUrl}
            alt=""
            className="h-5 w-5 object-contain opacity-80"
          />
        </div>
      </div>

      {loading ? (
        <div className="h-8 w-20 animate-pulse rounded-lg bg-[#F3F4F6]" />
      ) : (
        <p className="text-[28px] font-bold leading-none tracking-tight text-[#111827]">
          {Number(number || 0).toLocaleString()}
        </p>
      )}

      <div className="mt-3 flex items-end justify-between">
        <span className="text-xs text-[#9CA3AF]">Assigned to you</span>
        <Sparkline color={accent.spark} />
      </div>
    </div>
  );
}

export default CustomTile;
